export default "__VITE_ASSET__CwLchTAl__"